__webpack_require__.p = "/fewer-confirmation-dialogs-/referrals/";